import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { Divider } from '../Divider';
import { tabListStyles } from './TabList.styles';
import { Base } from '../Base';
export const TabList = forwardRef(function TabList(props, forwardedRef) {
    const { styles, sx, children, fullWidth, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'TabList',
        styles: [tabListStyles, styles],
    });
    return (_jsxs(Base, { role: 'tablist', "aria-orientation": 'horizontal', ...other, sx: [globalStyles, combineStyles('host'), sx], ref: forwardedRef, children: [_jsx("div", { ...getStyles('tabList', fullWidth && 'tabList$fullWidth'), children: children }), _jsx(Divider, {})] }));
});
